module.exports = __webpack_public_path__ + "static/media/ws-premium-43.adfba996.PNG";